import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3060a8e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "left"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title-box"
}, [/*#__PURE__*/_createTextVNode("新闻资讯 "), /*#__PURE__*/_createElementVNode("a", {
  class: "span",
  href: "/corporateBlog.html?type=2"
}, "了解更多")], -1));
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = {
  class: "article-content"
};
const _hoisted_5 = {
  class: "button-box"
};
const _hoisted_6 = {
  class: "right"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title-box"
}, [/*#__PURE__*/_createTextVNode("技术分享 "), /*#__PURE__*/_createElementVNode("a", {
  class: "span",
  href: "/corporateBlog.html?type=3"
}, "了解更多")], -1));
const _hoisted_8 = {
  class: "list-box"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "article-time"
};
const _hoisted_11 = {
  class: "article-content"
};
const _hoisted_12 = {
  class: "button-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_buttom_com = _resolveComponent("buttom-com");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.pageActive ? 'bolg-list-box active' : 'bolg-list-box')
  }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = $event => _ctx.lookInfo(_ctx.News)),
    class: "news-box"
  }, [_createElementVNode("img", {
    class: "article-img",
    src: _ctx.News.blogCoverPage,
    alt: _ctx.News.blogTitle
  }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("h3", null, _toDisplayString(_ctx.News.blogTitle), 1)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_buttom_com, {
    btnName: "了解更多",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.jumpPage('/corporateBlog.html?type=2')),
    filling: true
  })])])]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("ul", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Techs, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: "article-box",
      key: index,
      onClick: $event => _ctx.lookInfo(item),
      style: {
        "cursor": "pointer"
      }
    }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, _toDisplayString(item.blogTimeD), 1), _createTextVNode(_toDisplayString(item.blogTimeY), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("h3", null, _toDisplayString(item.blogTitle), 1)])], 8, _hoisted_9);
  }), 128))]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_buttom_com, {
    btnName: "了解更多",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.jumpPage('/corporateBlog.html?type=3')),
    filling: true
  })])])], 2);
}